// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CachedItemMerge } from '@/audit/api/types';
import { Stack, Typography } from '@mui/material';

interface Props {
  property: CachedItemMerge;
}

export function AuditMergedItemEntityLabel(props: Props) {
  const item = props.property.newValue!;

  return (
    <Stack spacing={0.5}>
      <Typography component="span" variant="caption" fontWeight="bold">
        Merged item:
      </Typography>

      <Typography variant="caption" paddingLeft={2}>
        <Typography
          component="span"
          variant="inherit"
          sx={{ fontWeight: 'bold' }}
        >
          Name:
        </Typography>{' '}
        {item.name}
      </Typography>

      {item.sku && (
        <Typography variant="caption" paddingLeft={2}>
          <Typography
            component="span"
            variant="inherit"
            sx={{ fontWeight: 'bold' }}
          >
            SKU:
          </Typography>{' '}
          {item.sku}
        </Typography>
      )}

      <Typography variant="caption" paddingLeft={2}>
        <Typography
          component="span"
          variant="inherit"
          sx={{ fontWeight: 'bold' }}
        >
          Type:
        </Typography>{' '}
        {item.nonInventory ? 'Non-inventory' : 'Inventory'}
      </Typography>

      {item.description && (
        <Typography variant="caption" paddingLeft={2}>
          <Typography
            component="span"
            variant="inherit"
            sx={{ fontWeight: 'bold' }}
          >
            Description:
          </Typography>{' '}
          {item.description}
        </Typography>
      )}

      {item.fields && item.fields.length > 0 && (
        <>
          <Typography
            component="span"
            variant="caption"
            fontWeight="bold"
            sx={{ mt: 1 }}
          >
            Custom fields:
          </Typography>
          {item.fields.map((field, index) => (
            <Typography key={index} variant="caption" paddingLeft={2}>
              <Typography
                component="span"
                variant="inherit"
                sx={{ fontWeight: 'bold' }}
              >
                {field.name}:
              </Typography>{' '}
              {(() => {
                const typeMapping: Record<string, string> = {
                  TEXT: 'Text',
                  MULTILINE_TEXT: 'Multiline text',
                  INTEGER: 'Integer',
                  NUMBER: 'Decimal',
                  DATE: 'Date',
                  DATE_TIME: 'Date and time',
                  TIME: 'Time',
                  BOOLEAN: 'Boolean',
                };
                return typeMapping[field.type] || field.type;
              })()}{' '}
              ({field.mergeType === 'added' ? 'added' : 'combined'})
            </Typography>
          ))}
        </>
      )}
    </Stack>
  );
}
